"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconComponent = _interopRequireDefault(require("./utils/IconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function User(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react["default"].createElement(_IconComponent["default"], _extends({
    name: "user",
    size: "".concat(size),
    viewboxSize: "512"
  }, props), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("circle", {
    "class": "icon-bg",
    fill: "#FFF",
    cx: "257",
    cy: "157",
    r: "117"
  }), _react["default"].createElement("path", {
    d: "M401.326 432.347v-10.684c0-79.564-65.099-144.663-144.663-144.663C177.099 277 112 342.099 112 421.663v10.684c0 20.687 16.769 37.456 37.456 37.456h214.415c20.686 0 37.455-16.771 37.455-37.456",
    "class": "icon-fill",
    fill: "#2CD5C4"
  }), _react["default"].createElement("path", {
    d: "M256.954 57.348c-54.924 0-99.607 44.684-99.607 99.607s44.682 99.607 99.607 99.607 99.607-44.684 99.607-99.607c0-54.924-44.683-99.607-99.607-99.607m0-29.348c71.105 0 128.954 57.849 128.954 128.954 0 50.73-29.445 94.712-72.14 115.752 59.563 23.09 101.906 81.008 101.906 148.631v10.684c0 28.744-23.385 52.129-52.129 52.129H149.128C120.384 484.15 97 460.765 97 432.021v-10.684c0-67.885 42.672-125.99 102.602-148.901C157.198 251.295 128 207.47 128 156.954 128 85.849 185.849 28 256.954 28zm-.617 263.346c-71.677 0-129.99 58.314-129.99 129.99v10.684c0 12.562 10.22 22.782 22.781 22.782h214.417c12.562 0 22.781-10.22 22.781-22.782v-10.684c0-71.676-58.312-129.99-129.989-129.99z",
    "class": "icon-outline",
    fill: "#1436B8"
  }))));
}

User.defaultProps = {
  size: 30
};
var _default = User;
exports["default"] = _default;